import { AppThunk } from '../../../store/rootReducer';
import { leadNamesSelector } from '../../ecg/selectors/signal.selectors';
import { currentLeadsSelector } from '../selectors/create.selectors';
import { selectedWavesSelector } from '../selectors/wave.selectors';
import { copyWave, invalidTypes, isWaveOfType } from '../utils/wave.util';
import { addWave } from './add-wave.thunk';

export const pasteWaves = (): AppThunk => async (dispatch, getState) => {
  const selectedWaves = selectedWavesSelector(getState());
  const leadNames = leadNamesSelector(getState());
  const currentLeads = currentLeadsSelector(getState());

  const waves = selectedWaves.filter((wave) =>
    isWaveOfType(wave, ...invalidTypes),
  );

  waves.forEach((wave) => {
    const newWave = copyWave(wave);
    const filteredTags = newWave.tags.filter(
      (tag) => leadNames.indexOf(tag) === -1,
    );
    dispatch(addWave({ ...newWave, tags: [...filteredTags, ...currentLeads] }));
  });
};
